import React, { useCallback, useEffect, useRef, useState } from 'react';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import { isNative, getPlatform } from '../utils/platformUtils';
import { getDeviceStore } from '../config/appLinks';
import { openExternal } from '../lib/openExternal';
import { track } from '../utils/analytics';
import { YouRow } from './YouPrimitives';

const SUBTITLE = 'Ten seconds, it helps a lot';
const THANKS = 'Thanks';
const THANKS_MS = 2500;

export default function RateRow({ dense = false }) {
  const [thanking, setThanking] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const native = isNative();
  const store = native ? null : getDeviceStore();

  const handleClick = useCallback(() => {
    track('rate_app_tapped', { platform: getPlatform() });

    if (!native) {
      if (store) openExternal(store.url);
      return;
    }

    // iOS peut decider de ne rien afficher : le remerciement ne depend pas de
    // ce que rend le plugin, sinon le tap n'aurait aucune reponse visible.
    clearTimeout(timer.current);
    setThanking(true);
    timer.current = setTimeout(() => setThanking(false), THANKS_MS);

    (async () => {
      try {
        const { InAppReview } = await import('@capacitor-community/in-app-review');
        await InAppReview.requestReview();
      } catch {
        // Rien a dire au joueur : une note refusee n'est pas une erreur.
      }
    })();
  }, [native, store]);

  if (!native && !store) return null;

  // En dense la rangee n'a pas de sous-titre : seul le remerciement s'affiche,
  // en queue de rangee.
  const subtitle = thanking ? THANKS : (dense ? undefined : SUBTITLE);

  return (
    <YouRow
      icon={<StarOutlineRoundedIcon />}
      accent
      dense={dense}
      title="Rate upScale"
      subtitle={subtitle}
      onClick={handleClick}
    />
  );
}
